/**
 * The in-app browsers of the apps that open a restaurant's link inside themselves: the Google app on
 * iOS (GSA), Instagram, Facebook and Messenger, TikTok, Snapchat, Pinterest, LINE, X. Their WebViews
 * often keep third-party iframes such as Stripe's from ever getting ready, which is the browser's
 * doing, not the checkout's.
 */
const IN_APP_BROWSER_PATTERN =
  /\bGSA\/|Instagram|FBAN\/|FBAV\/|FB_IAB|FBIOS|MessengerForiOS|musical_ly|BytedanceWebview|TikTok|Snapchat|Pinterest|\bLine\/|Twitter/i;

export function isInAppBrowser(userAgent: string | undefined = globalThis.navigator?.userAgent): boolean {
  return typeof userAgent === 'string' && IN_APP_BROWSER_PATTERN.test(userAgent);
}
